// extracted by mini-css-extract-plugin
export default {"ErrorFlash":"ChecksGroup-module__ErrorFlash--WJCJc","ErrorOcticon":"ChecksGroup-module__ErrorOcticon--JPT2T"};